import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ProgramVm } from 'qp-ui-interface';
import { AdobeService } from '../../shared/services/adobe/adobe.service';
import { StorefrontPolicyService } from '../../shared/services/firstlight/storefront-policy/storefront-policy.service';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';
import { NavigationLibraryService } from '../../shared/services/navigation/navigation.service';
import { isBlockedContent } from '../../shared/utils/buttonDetails';
import { isLoggedIn } from '../../shared/utils/LoginUtils';

@Component({
  selector: 'app-epg-details',
  templateUrl: './epg-details.component.html',
  styleUrls: ['./epg-details.component.scss'],
})
export class EpgDetailsComponent implements OnInit, OnChanges {
  @Input() program: ProgramVm;
  @Output() close = new EventEmitter();
  @Output() play = new EventEmitter<ProgramVm>();
  @Output() signIn = new EventEmitter();
  @Output() locked = new EventEmitter();
  constructor(
    private navService: NavigationLibraryService,
    private policyService: StorefrontPolicyService,
    private localStorage: LocalStorageService,
    private adobeService: AdobeService
  ) {}

  get dateLocale() {
    return this.policyService.getLocale();
  }

  get isPlayable() {
    return !isBlockedContent(this.adobeService.fullEntitlementPackages, this.program.entitlement);
  }

  get isLoggedIn() {
    return isLoggedIn(this.localStorage);
  }

  ngOnInit(): void {}

  ngOnChanges(change: SimpleChanges): void {
    if (change.program) {
      const { currentValue, previousValue } = change.program;
      if (previousValue === undefined && currentValue !== undefined) {
        this.navService.focusContainer('program-panel', true);
      }
    }
  }

  getRatingDetails(): string {
    let stringToReturn = 'NR';
    if (this.program && this.program.ratings?.length > 0) {
      // TODO change this value to a configurable value
      const ratingToShow = this.program.ratings.find((rat) => rat.s === 'USA Parental Rating');
      if (ratingToShow) stringToReturn = ratingToShow.v;
      else stringToReturn = this.program.ratings[0].v || 'NR';
    }
    return stringToReturn;
  }
}
